module.exports = __webpack_public_path__ + "static/media/sb.79392615.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/sb.svg
// module id = 239
// module chunks = 0